var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SalesReportTemplate',{attrs:{"title":"Sales by Invoice","columns":_vm.columns,"fetchRoute":"/reports/sales-general-report","permission":_vm.PERMISSION_CODES.CMS_VIEW_REPORT_SALES_REPORT,"reportTypeCode":_vm.REPORT_MASTER_CODES.SALES_GENERAL}})
}
var staticRenderFns = []

export { render, staticRenderFns }